﻿import { UIGameObject } from "../Tools/Base/UIGameObject";
import { UIText } from "../Tools/Base/UIText";
import { UICommonPopup } from "../Tools/Base/UICommonPopup";
import { UINineSliceButton } from "../Tools/Base/UINineSliceButton";
import { Core } from "../../Base/Core";
import { isHapticAvailable } from "../../../dpCommonPortHelper";

class OnOffButton extends UINineSliceButton {
    constructor(value, ...args) {
        super("btn-orange", ...args);
        this._value = !!value;
        this.updateUI();
        this.on("pointertap", () => (this.value ^= true));
    }

    get value() {
        return !!this._value;
    }

    set value(val) {
        val = !!val;
        let changed = this._value ^ val;
        this._value = val;
        this.updateUI();
        if (changed) {
            this.emit("changed", val);
        }
    }

    updateUI() {
        this.label = Core.Localizator.Get(this._value ? "on" : "off");
        this.setImage(this._value ? "btn-blue" : "btn-orange");
    }
}

export class UISettings extends UICommonPopup {
    resetBtnShowDelay = 600000;

    Awake() {
        super.Awake({
            title: Core.Localizator.Get("settings"),
            closeButton: true,
        });

        this.musicText = this.content.addChild(new UIText(Core.Localizator.Get("music")));
        this.soundText = this.content.addChild(new UIText(Core.Localizator.Get("sound")));
        this.vibroText = this.content.addChild(new UIText(Core.Localizator.Get("vibro")));

        this.soundBtn = this.content.addChild(new OnOffButton(Core.LocalSettings.Sound));
        this.musicBtn = this.content.addChild(new OnOffButton(Core.LocalSettings.Music));
        this.vibroBtn = this.content.addChild(new OnOffButton(Core.LocalSettings.Vibro));

        this.idContainer = this.content.addChild(new UIGameObject()); // GameObject idContainer;
        this.idField = this.content.addChild(new UIText()); // Text idField;
        this.resetBtn = this.addChild(
            new UINineSliceButton("btn-orange", {
                label: Core.Localizator.Get("reset_button"),
            })
        );
        this.HideWithBackButton = true;

        this.soundBtn.on("changed", (val) => (Core.LocalSettings.Sound = !!val));
        this.musicBtn.on("changed", (val) => (Core.LocalSettings.Music = !!val));
        this.vibroBtn.on("changed", (val) => {
            Core.LocalSettings.Vibro = !!val;
            if (val) Core.Vibro.Vibrate(true);
        });

        this.resetBtn.on("pointertap", () => {
            Core.UI.reset.Show();
            this.Hide();
        });
    }

    Init() {
        super.Init();
        this.soundBtn.value = Core.LocalSettings.Sound;
        this.musicBtn.value = Core.LocalSettings.Music;
        this.vibroBtn.value = Core.LocalSettings.Vibro;

        //show once per hour
        if (Date.now() - Core.Player.Timers.registrationTime > this.resetBtnShowDelay) {
            this.resetBtn.visible = true;
        }
        const hapticAvailable = isHapticAvailable();
        this.vibroBtn.visible = hapticAvailable;
        this.vibroText.visible = hapticAvailable;
    }

    hideResetBtn() {
        this.resetBtn.visible = false;
    }

    updateUI() {}

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 1;
        let w = Math.min(viewport.width * 0.8, (viewport.height * 0.8) / sideRatio);
        let h = w * sideRatio;

        this.setPopupRect(new PIXI.Rectangle((viewport.width - w) * 0.5, (viewport.height - h) * 0.5, w, h));

        super.fitLayout(viewport);

        let popupRect = this.getContentSize();

        let rect = popupRect.clone();
        rect.height = popupRect.height * 0.13;
        rect.width = popupRect.width * 0.42;
        rect.x = (popupRect.width - rect.width) * 0.1;
        rect.y = (popupRect.height - rect.height) * 0.28;
        this.musicText.fitLayout(rect);

        rect.x = (popupRect.width - rect.width) * 0.9;
        this.soundText.fitLayout(rect);

        rect.width = popupRect.width * 0.55;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.72;
        this.vibroText.fitLayout(rect);

        rect = popupRect.clone();
        rect.height = popupRect.height * 0.15;
        rect.width = popupRect.width * 0.36;
        rect.x = this.musicText.x - rect.width * 0.5;
        rect.y = this.musicText.y + this.musicText.height * 0.5 + h * 0.04;
        this.musicBtn.fitLayout(rect);

        rect.x = this.soundText.x - rect.width * 0.5;
        this.soundBtn.fitLayout(rect);

        rect.x = this.vibroText.x - rect.width * 0.5;
        rect.y = this.vibroText.y + this.vibroText.height * 0.5 + h * 0.02;
        this.vibroBtn.fitLayout(rect);

        rect = popupRect.clone();
        rect.height = popupRect.height * 0.2;
        rect.width = popupRect.width * 0.53;
        rect.x = (viewport.width - rect.width) * 0.5;
        rect.y = (viewport.height - rect.height) * 0.97;
        this.resetBtn.fitLayout(rect);
    }

    Show() {
        this.Init();
        super.Show();
    }
}
